import React from 'react';
import {BlocksControls, InlineTextarea} from 'react-tinacms-inline';
import PropTypes from 'prop-types';
import {box, text} from '../../constants/fields/fields';
import HTitle from './HTitle';
import {useBlockProps} from '../../hooks/useBlockProps';
import {usePage} from '../../contexts/PageContext';
import {titleTemplate} from '../../constants/templates/title';
import {Content} from '../Common/Content';

function TitleComponent({index, data}) {
  const {blockProps} = useBlockProps(data);
  const {language} = usePage();
  return (
    <BlocksControls index={index} focusRing={{offset: 0}}>
      <Content {...blockProps} title={''}>
        <HTitle level={blockProps?.level}
          text={blockProps.text}
          viewport={blockProps.viewport}>
          <InlineTextarea name={`title.${language}`} focusRing={false}/>
        </HTitle>
      </Content>
    </BlocksControls>
  );
}

const template = {
  label: 'Title',
  defaultItem: titleTemplate,
  fields: [
    {
      name: 'level',
      label: 'Level',
      component: 'select',
      options: [1, 2, 3, 4, 5],
    },
    text,
    box
  ]
};
export const Title = {
  Component: TitleComponent,
  template
};

TitleComponent.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number
};
